<div class="technique-container">
    <!-- 閉じるボタン -->
    <button class="close-tech-btn" (click)="close()" title="閉じる">
        <i class="fas fa-times"></i>
    </button>

    <div class="selection-header">
        <h2 class="title">CHOOSE YOUR TECHNIQUE</h2>
        <p class="subtitle">最大3つまで選択してください ({{ selectedTechniques.length }} / 3)</p>
    </div>

    <div class="technique-grid">
        <div *ngFor="let tech of techniques" class="tech-item" [class.selected]="isSelected(tech)"
            [class.locked]="isLocked(tech)" (mouseenter)="onHover(tech)" (mouseleave)="onLeave()"
            (click)="toggleSelection(tech)">

            <div class="tech-image-wrapper">
                <img [src]="'./assets/images/raigo/' + tech + '.jpg'" class="tech-image" [alt]="tech">
                <div class="tech-overlay"></div>
                <div class="lock-icon" *ngIf="isLocked(tech)">
                    <i class="fas fa-lock"></i>
                </div>
                <div class="check-icon" *ngIf="isSelected(tech)">
                    <i class="fas fa-check-circle"></i>
                </div>
            </div>
        </div>
    </div>


    <div class="footer-actions">
        <button class="confirm-btn" (click)="confirm()">
            <span class="btn-text">決定 - ENTER BATTLE</span>
            <div class="btn-glow"></div>
        </button>
    </div>
</div>